var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('h3',[_vm._v("Mis beneficios")]),_c('p',[_vm._v(" Consulta los beneficios que tienes como miembro / afiliado de la organización. ")])]),_vm._l((_vm.benefitsList),function(item,i){return _c('v-col',{key:i,attrs:{"cols":_vm.$vuetify.breakpoint.smAndDown
          ? 12
          : _vm.$vuetify.breakpoint.lgAndDown
          ? 12
          : 4}},[_c('benefitsCard',{attrs:{"name":item.name,"description":item.description,"icon":item.icon,"url":item.url}})],1)})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }